import {
  MilestoneAttributeDisplay,
  MilestoneDates,
  MilestonePanelExpanded,
  MilestonePanelHeaderSection,
} from "@/containers/Project/components";
import * as S from "@/containers/Project/components/styled";
import { CONTENT_WIDTH } from "@/enums";
import { projectMilestoneType } from "@/propTypes";
import { Col, Row } from "antd";
import { bool, func, number, object, string } from "prop-types";
import { MilestoneActionDrawer } from "./MilestoneActionDrawer";
import { MilestoneActionCol } from "./styled";

const MilestonePanelLayoutMobile = ({
  milestone,
  childLevel,
  maxChildLevel,
  expanded,
  toggleExpanded,
  parentId,
  toggleChildren,
  targetDatesRequired,
  skuRequired,
  canUser,
  project,
  setProject,
  isAdmin,
}) => {
  return (
  <>
    <Row>
      <Col flex={1}>
        <Row>
          <Col flex={1}>
            <S.StyledContentCard
              $status={milestone.status}
              styles={{ body: { height: "65px", padding: "0px 0px 0px 10px" } }}
            >
              <Row
                align="middle"
                justify="space-between"
                style={{ height: "100%" }}
              >
                <Col span={CONTENT_WIDTH.twoThirds} offset={childLevel}>
                  <S.MinWidthDiv $min={174}>
                    <MilestonePanelHeaderSection
                      milestone={milestone}
                      childLevel={childLevel}
                      expanded={expanded}
                      toggleExpanded={toggleExpanded}
                      toggleChildren={toggleChildren}
                    />
                  </S.MinWidthDiv>
                </Col>
                <MilestoneActionCol>
                  <MilestoneAttributeDisplay
                    milestone={milestone}
                    targetDatesRequired={targetDatesRequired}
                    skuRequired={skuRequired}
                  />
                  <MilestoneActionDrawer
                    milestone={milestone}
                    childLevel={childLevel}
                    maxChildLevel={maxChildLevel}
                    parentId={parentId}
                  />
                </MilestoneActionCol>
              </Row>
            </S.StyledContentCard>
          </Col>
        </Row>

        {expanded && (
          <S.StyledMilestonePanelExpanded>
            <Col flex={1}>
              <S.StyledContentCardExpansion>
                <Row align={"middle"}>
                  <Col span={CONTENT_WIDTH.max}>
                    <MilestoneDates
                      milestone={milestone}
                      canUser={canUser}
                      project={project}
                      setProject={setProject}
                    />
                  </Col>
                </Row>
                <div>
                  <MilestonePanelExpanded
                    milestone={milestone}
                    childLevel={0}
                    skuRequired={skuRequired}
                  />
                </div>
              </S.StyledContentCardExpansion>
            </Col>
          </S.StyledMilestonePanelExpanded>
        )}
      </Col>
    </Row>
  </>
  );
};

MilestonePanelLayoutMobile.propTypes = {
  milestone: projectMilestoneType,
  childLevel: number,
  maxChildLevel: number,
  expanded: bool,
  toggleExpanded: func,
  parentId: string,
  toggleChildren: func,
  targetDatesRequired: bool,
  skuRequired: bool,
  canUser: func,
  project: object,
  setProject: func,
  isAdmin: bool,
};

export { MilestonePanelLayoutMobile };
